<template>
	<section class="ctn">
		<header class="header left">
			<router-link class="paper-action" :to="{ path: `/types`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
		</header>
		<main class="siteType-details">
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ siteType.type }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
            <div class="row" v-for="site in sites" :key="`siteTypeProject-${site.id}`">
							<div class="details-row">
								<span><router-link :to="{ path: `/sites/${site.id}/details` }">{{ site.name }}</router-link></span>
								<span class="badge">
                 <a :href="site.url" target="_blank">{{ site.url }}</a></span>
							</div>
						</div>
					</main>
				</heim-card>
			</section>
		</main>
	</section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";

export default {
  name: "SiteTypesDetails",
  components: {
    HeimIcon,
    HeimCard
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getSiteType", id);
    this.$store.dispatch("getSiteInType", id);

    this.$watch(
      vm => vm.siteType,
      val => {
        this.$store.dispatch("setTitle", `SiteType - ${val.type}`);
      }
    );
  },
  computed: {
    ...mapState({
      sites: state => state.sitesState.siteType,
      siteType: state => state.typesState.siteType
    })
  },
  methods: {}
};
</script>

<style scoped>
.siteType-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.siteType-details > .paper-card,
.siteType-details > .info {
  width: 100%;
  margin-right: 0;
}

.siteType-details .stats,
.siteType-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring {
  border-radius: 0;
}
.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .siteType-details {
    flex-wrap: nowrap;
  }
  .siteType-details > .paper-card,
  .siteType-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
